'use strict';

angular.module('AcaApp').controller('FormDependentController', [
  '$scope',
  '$mdDialog',
  '$timeout',
  'ShortcutsService',
  'subscriber',
  'FormService',
  'DependentService',
  'FORM_MESSAGES',
  'UtilsService',
  'currentForm',
  '$rootScope',
  'EXCEPTION',
  'LayoutService',
  '$window',
  //jscs:disable maximumLineLength
  function($scope, $mdDialog, $timeout, ShortcutsService, subscriber, FormService, DependentService, FORM_MESSAGES, UtilsService, currentForm, $rootScope, EXCEPTION, LayoutService, $window){
    $scope.coveredIndividuals = [];
    $scope.$DependentService = DependentService;
    $scope.formAction = '';
    $scope.validationFlagDependent = false;
    $scope.validationsBE = false;
    $scope.isAloneDependent = false;
    $scope.aloneDependent = {};
    $scope.subscriberSelected = {};
    $scope.currentSubscriber = {};
    $scope.havePrinted = false;
    $scope.formChanged = false;
    $scope.taxyear = $window.sessionStorage.taxYear;
    var avoidNullification = -2147483648; //This number will be interpreted in the backend to avoid a nullification of stmtrun field
    var box = ($scope.taxyear >= 2020)? 18: 17;
    var method = '';
    var rpcValues = '';
    var recordModified = 'RECORDMODIFIED';
    var localFchar = '';
    var dependentStatus = 'D';
    var months = FormService.getMonths();
    var setMonthIndicator = function(indicator){
      return (indicator === '1');
    };
    if(subscriber !== undefined){
      $scope.formAction = 'add';
      $scope.subscriber = subscriber;
      if(subscriber instanceof Array){
        var model = {
          accountno: currentForm.accountno,
          box: box,
          tin: currentForm.tin,
          status: dependentStatus
        };
        $scope.coveredIndividuals.push(model);
        $scope.isAloneDependent = true;
      }
      else{
        $scope.isAloneDependent = false;
      }
    }
    else{
      $scope.formAction = 'edit';
      $scope.subscriber = {};
      $scope.subscriber = currentForm.Subscriber;
      var form = currentForm.Forms1095C ? currentForm.Forms1095C : currentForm.Forms1095B;
      $scope.subscriber.accountnoSub = form.accountno;
      $scope.subscriber.ptin = form.ptin;
      $scope.subscriber.employersponsor = form.employersponsor;
      $scope.subscriber.originofpolicy = form.originofpolicy;
      var model = {
        ptin: $scope.subscriber.ptin,
        datemodified: form.datemodified,
        modid: form.modid,
        taxyear: form.taxyear,
        modlevel: form.modlevel,
        recno: form.recno,
        recordversion: form.recordversion,
        accountno: $scope.subscriber.accountnoSub,
        status: dependentStatus,
        box: box,
        tin: form.tin,
        stmtrun: form.stmtrun,
        textValidationBackend: [],
        showValidationBackend: false,
        showMandatoryMessage: '',
        xmitrun: form.xmitrun,
        groupstatus: form.groupstatus
      };
      if(form.warnings !== undefined){
        if(form.warnings !== ''){
          model.textValidationBackend = UtilsService.errorMessageValidationForString(form.warnings);
          model.showValidationBackend = true;
        }
      }
      for(var j = 0; j < months.length; j++){
        model[months[j]] = setMonthIndicator(form[months[j] + 'indicator']);
      }
      model.all = $scope.$DependentService.isAllMonthSelected(model);
      $scope.coveredIndividuals.push(model);
    }

    var _formChanged = function(newValue, oldValue){
      if(newValue !== oldValue){
        $scope.formChanged = true;
      }
    };

    setTimeout(function(){
      $scope.$watch('coveredIndividuals', _formChanged, true);
    }, 1000);

    var idCoveredIndividual = 0;
    var closeModal = function(){
      ShortcutsService.enableBackSpaceDefault();
      $scope.validationFlagDependent = false;
      $mdDialog.hide();
    };
    $scope.closeModal = function(){
      $scope.validationFlagDependent = false;
      closeModal();
    };
    $scope.get1095BSubscriberForm = function(){
      $scope.currentSubscriber = angular.fromJson($scope.subscriberSelected.data);
      FormService.get1095BFormByModrecno($scope.currentSubscriber.modrecno).then(
        function(data){
          $scope.aloneDependent = data.result;
        },
        function(){
          alert('Error');
        }
      );
    };
    $scope.get1095CSubscriberForm = function(){
      if($scope.subscriberSelected.data !== undefined){
        if($scope.subscriberSelected.data !== ''){
          $scope.currentSubscriber = angular.fromJson($scope.subscriberSelected.data);
          FormService.get1095CFormByModrecno($scope.currentSubscriber.modrecno).then(
            function(data){
              $scope.aloneDependent = data.result;
            },
            function(){
              alert('Error');
            }
          );
        }
        else{
          $scope.aloneDependent = {ptin: ''};
        }
      }
      else{
        $scope.aloneDependent = {ptin: ''};
      }
    };
    $scope.addCovInd = function(){
      var coveredIndividual = {'id': idCoveredIndividual++};
      coveredIndividual.box = box++;
      coveredIndividual.status = dependentStatus;
      if($scope.isAloneDependent){
        coveredIndividual.accountno = $scope.aloneDependent.accountno;
        coveredIndividual.ptin = $scope.aloneDependent.ptin;
      }
      else{
        coveredIndividual.accountno = $scope.subscriber.accountnoSub;
        coveredIndividual.ptin = $scope.subscriber.ptin;
      }
      $scope.coveredIndividuals.push(coveredIndividual);
    };
    $scope.deleteIndividual = function(id){
      for(var i = 0; i < $scope.coveredIndividuals.length; i++){
        if($scope.coveredIndividuals[i].id === id){
          $scope.coveredIndividuals.splice(i, 1);
        }
      }
      if($scope.coveredIndividuals.length === 0){
        setIncompleteMessage('');
      }
    };
    $scope.save = function(form, fchar){
      localFchar = fchar;
      var mandatory = false;
      if($scope.coveredIndividuals.length > 0){
        if(!form.$valid){
          setIncompleteMessage(FORM_MESSAGES.INCOMPLETE);
          return true;
        }
        else{
          setIncompleteMessage('');
        }
        var rpcForm1095Dependent = [];
        for(var i = 0; i < $scope.coveredIndividuals.length; i++){
          if($scope.isAloneDependent){
            if(!$scope.subscriberSelected.data){
              $scope.coveredIndividuals[i].showMandatoryMessage = FORM_MESSAGES.REQUIREDPARTICIPANT;
              mandatory = true;
            }
            else{
              $scope.coveredIndividuals[i].showMandatoryMessage = '';
            }
          }
          else{
            if(!$scope.coveredIndividuals[i].data){
              $scope.coveredIndividuals[i].showMandatoryMessage = FORM_MESSAGES.REQUIREDPARTICIPANT;
              mandatory = true;
            }
            else{
              $scope.coveredIndividuals[i].showMandatoryMessage = '';
            }
          }
          if(!mandatory){
            var coveredIndividual = $scope.coveredIndividuals[i];
            rpcForm1095Dependent[i] = {
              tin: coveredIndividual.data.tin,
              status: coveredIndividual.status,
              accountno: coveredIndividual.accountno,
              ptin: coveredIndividual.ptin !== undefined ? coveredIndividual.ptin : $scope.aloneDependent.ptin,
              xmitrun: coveredIndividual.xmitrun !== undefined ? coveredIndividual.xmitrun : $scope.aloneDependent.xmitrun
            };
            for(var j = 0; j < months.length; j++){
              rpcForm1095Dependent[i][months[j] + 'indicator'] = $scope.setValueRPC(coveredIndividual[months[j]]);
            }
            if(coveredIndividual.recno !== undefined){
              rpcForm1095Dependent[i].recno = coveredIndividual.recno;
            }
            if(coveredIndividual.recordversion !== undefined){
              rpcForm1095Dependent[i].recordversion = coveredIndividual.recordversion;
            }
            if(coveredIndividual.modlevel !== undefined){
              rpcForm1095Dependent[i].modlevel = coveredIndividual.modlevel;
            }
            if(coveredIndividual.taxyear !== undefined){
              rpcForm1095Dependent[i].taxyear = coveredIndividual.taxyear;
            }
            if(coveredIndividual.modid !== undefined){
              rpcForm1095Dependent[i].modid = coveredIndividual.modid;
            }
            if(coveredIndividual.datemodified !== undefined){
              rpcForm1095Dependent[i].datemodified = coveredIndividual.datemodified;
            }
            if(coveredIndividual.groupstatus !== undefined){
              rpcForm1095Dependent[i].groupstatus = coveredIndividual.groupstatus;
            }
            if(!$scope.isAloneDependent){
              if($scope.subscriber.employersponsor){
                rpcForm1095Dependent[i].employersponsor = $scope.subscriber.employersponsor;
              }
              if($scope.subscriber.originofpolicy){
                rpcForm1095Dependent[i].originofpolicy = $scope.subscriber.originofpolicy;
              }
            }
            else{
              if($scope.aloneDependent.employersponsor){
                rpcForm1095Dependent[i].employersponsor = $scope.aloneDependent.employersponsor;
              }
              if($scope.aloneDependent.originofpolicy){
                rpcForm1095Dependent[i].originofpolicy = $scope.aloneDependent.originofpolicy;
              }
            }
          }
        }
        if($scope.formAction === 'add'){
          rpcValues = {'list': rpcForm1095Dependent};
          method = (fchar === 'X5B') ? 'save1095BCoveredIndividuals' : 'save1095CDependent';
          if(fchar == 'X5B'){
            $scope.formX5 = {};
            $scope.formX5.ptin = rpcValues.list[0].ptin;
            $scope.formX5.fk2 = rpcValues.list[0].accountno;
            $scope.formX5.c14 = rpcValues.list[0].originofpolicy;
            $scope.formX5.s01 = rpcValues.list[0].employersponsor;
            FormService.areThereX5BPrinted($scope.formX5).then(function(data){
              $scope.havePrinted = checkPrinted(data.result.value);
              checkMandatory(mandatory);
            });
          }
          if(fchar == 'X5C'){
            $scope.formX5 = {};
            $scope.formX5.ptin = rpcValues.list[0].ptin;
            $scope.formX5.fk2 = rpcValues.list[0].accountno;
            FormService.areThereX5CPrinted($scope.formX5).then(function(data){
              $scope.havePrinted = checkPrinted(data.result.value);
              checkMandatory(mandatory);
            });
          }
        }
        else{
          rpcForm1095Dependent[0].stmtrun = ($scope.coveredIndividuals[0].stmtrun !== undefined) ? 0 : avoidNullification;
          rpcValues = rpcForm1095Dependent[0];
          method = (fchar === 'X5B') ? 'update1095B' : 'update1095C';
          checkMandatory(mandatory);
        }
      }
      else{
        $scope.messageModal = $scope.formAction + 'Subscriber';
        openConfirmationModal(fchar);
      }
    };

    var checkMandatory = function(mandatory){
      if(!mandatory){
        if($scope.coveredIndividuals[0].stmtrun !== undefined || $scope.havePrinted){
          $mdDialog.show({
            templateUrl: 'app/views/form/modals/printCorrection.html',
            preserveScope: true,
            scope: $scope
          });
        }
        else{
          upsertDependent();
        }
      }
    };

    var checkPrinted  = function(isPrinted) {
      rpcValues.list[0].stmtrun = (isPrinted > 0) ? 0 : avoidNullification;
      return isPrinted > 0;
    };

    $scope.reprintYes = function(){
      $mdDialog.hide();
      $scope.coveredIndividuals[0].stmtrun = 0;
      if($scope.formAction === 'add'){
        rpcValues.list[0].stmtrun = 0;
      }
      else {
        rpcValues.stmtrun = $scope.coveredIndividuals[0].stmtrun;
      }
      upsertDependent();
    };

    $scope.reprintNot = function(){
      $mdDialog.hide();
      if($scope.formAction === 'add'){
        rpcValues.list[0].stmtrun = avoidNullification;
      }
      else {
        rpcValues.stmtrun = $scope.coveredIndividuals[0].stmtrun;
      }
      upsertDependent();
    };

    $scope.reprintCancel = function(){
      var templateFormName = (localFchar === 'X5B') ? '1095B' : '1095C';
      $mdDialog.show({
        templateUrl: 'app/views/form/modals/form' + templateFormName + 'Dependent.html',
        preserveScope: true,
        onComplete: function(){
          selectedCombo();
        },
        scope: $scope
      });
    };

    var upsertDependent = function(){ //this method will do dinamically an insert or update of depedents according at the filters
      FormService[method](rpcValues, $scope.validationFlagDependent).then(
        function(data){
          if(data.result.DataBool){
            $rootScope.isRefresh = 'refreshForm';
            $scope.validationFlagDependent = false;
            $scope.messageModal = $scope.formAction + 'Dependent';
            openConfirmationModal(localFchar);
          }
          else{
            for(var i = 0; i < $scope.coveredIndividuals.length; i++){
              $scope.coveredIndividuals[i].showMandatoryMessage = '';
            }
            $scope.reprintCancel();
            enabledError(data.result);
          }
        },
        function(error){
          //jscs:disable requireCamelCaseOrUpperCaseIdentifiers
          if(error.data.error.frontend_code === recordModified){
            setErrorMessage(error.data.error.frontend_message);
          }
          else{
            var errorMsg;
            if($scope.formAction === 'add'){
              if(error.data.error.frontend_code === EXCEPTION.DUPLICATEDFORM){
                errorMsg = (localFchar === 'X5B') ? duplicateForm('1095B') : duplicateForm('1095C');
              }
              else{
                errorMsg = (localFchar === 'X5B') ? FORM_MESSAGES.ERRORSAVING1095BDEP : FORM_MESSAGES.ERRORSAVING1095CDEP;
              }
            }
            else{
              errorMsg = (localFchar === 'X5B') ? FORM_MESSAGES.ERRORUPDATING1095BDEP : FORM_MESSAGES.ERRORUPDATING1095CDEP;
            }
            setErrorMessage(errorMsg);
          }
        }
      );
    };

    var duplicateForm = function(fcharForm){
      $scope.FormName = fcharForm;
      $mdDialog.show({
        templateUrl: 'app/views/form/modals/duplicateDependentForm.html',
        preserveScope: true,
        scope: $scope
      });
    };

    var openConfirmationModal = function(fchar){
      $mdDialog.show({
        controller: [
          '$scope',
          function($scope){
            $scope.fchar = fchar;
            $scope.closeModal = function(){
              closeModal();
            };
          }
        ],
        templateUrl: 'app/views/form/modals/' + $scope.messageModal + 'SuccessMessage.html'
      });
    };

    $scope.setValueRPC = function(value){
      return (value === undefined || value === false) ? '' : '1';
    };

    $scope.validateCheck = function(dependent){
      var isDependentData = dependent.data !== null && dependent.data !== undefined;
      months.push('all');
      if(isDependentData){
        //jscs:disable validateNewlineAfterArrayElements
        for(var i = 0; i < months.length; i++){
          if(!$scope.validateCheckValue(dependent[months[i]])){
            return false;
          }
        }
      }
      setIncompleteMessage(FORM_MESSAGES.INCOMPLETE);
      return true;
    };
    $scope.validateCheckValue = function(value){
      if(value !== undefined && value === true){
        setIncompleteMessage('');
        return false;
      }
      return true;
    };
    var setErrorMessage = function(value){
      $scope.errorMessage = value;
    };
    var setIncompleteMessage = function(value){
      $scope.incompleteMessage = value;
    };
    var enabledError = function(error){
      var i = 0;
      $scope.validationFlagDependent = true;
      if(error.Responses instanceof Array) {
        $scope.validationMessage = UtilsService.errorMessageValidationForArray(error.Responses);
        for(i; i < $scope.validationMessage.length; i++){
          var checkMessage = ($scope.validationMessage[i].ErrorMessage !== undefined);
          $scope.coveredIndividuals[i].textValidationBackend = (checkMessage) ? $scope.validationMessage[i].ErrorMessage : '';
          $scope.coveredIndividuals[i].showValidationBackend = checkMessage;
        }
      }
      else{
        $scope.coveredIndividuals[0].textValidationBackend = UtilsService.errorMessageValidationForString(error.ErrorMessage);
        $scope.coveredIndividuals[0].showValidationBackend = true;
      }
    };
    var selectedCombo = function(){
      $timeout(
        function(){
          if(isUndefined()){
            LayoutService.setSelectBoxChange('#subscriber-selected', $scope.subscriberSelected.data, '#subscriber-label');
          }
        }
      );
    };
    var isUndefined = function(){
      return $scope.subscriberSelected.data !== undefined;
    };
    selectedCombo();
    $scope.isDisabledSearchAutocomplete = ($scope.formAction !== 'add' || $scope.isAloneDependent);
  }
]);
